import { initialsOf } from '@/lib/image';

/** Round avatar: the customer's photo, or their initials on a branded disc. */
export function Avatar({
  name,
  avatarUrl,
  size = 40,
}: {
  name: string;
  avatarUrl: string | null;
  size?: number;
}) {
  const dim = { width: size, height: size };
  if (avatarUrl) {
    return <img className="avatar" src={avatarUrl} alt="" style={dim} width={size} height={size} />;
  }
  return (
    <span className="avatar avatar-initials" style={{ ...dim, fontSize: Math.round(size * 0.4) }} aria-hidden="true">
      {initialsOf(name)}
    </span>
  );
}
